/**
  Throttle is used to call a function after every millisecond or
  a particular interval of time only
  the first click is executed immediately.
* */
export default function throttle(callback, limit) {
  let wait = false;
  return () => {
    if (!wait) {
      callback.call();
      wait = true;
      setTimeout(() => {
        wait = false;
      }, limit);
    }
  };
}